<template>
    <div :class=" loaderFullContainer ? 'loader-full-container' : 'loader'">
        <div class="d-flex pt-2 align-items-center justify-content-center h-100">
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">{{ message }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: 'Loading...',
        },
        loaderFullContainer: {
            type: Boolean,
            default: false,
        }
    },
};
</script>
